/**
 * Helpers de tipografia para o relatório de Análise IA.
 * Sem emojis — hierarquia só com tipo e espaço (DS Adlitics).
 */

/** Remove pictogramas e espaços sobrando no início do título. */
export function stripLeadingDecorators(title: string): string {
    return title
        .replace(/^\s*#{1,6}\s*/, '')
        .replace(/^\s*\p{Extended_Pictographic}\s*/u, '')
        .replace(/\p{Extended_Pictographic}/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
}
